export const genreList = [
    {
        value: 'love',
        text: 'Love',
    },
    {
        value: 'horror',
        text: 'Horror',
    },
    {
        value: 'mystery_and_detective_stories',
        text: 'Mystery',
    },
    {
        value: 'poetry',
        text: 'Poetry',
    },
    {
        value: 'nutrition',
        text: 'Nutrition',
    },
    {
        value: 'dogs',
        text: 'Dogs',
    },
    {
        value: 'psychology',
        text: 'Psychology',
    },
    {
        value: 'programming',
        text: 'Programming',
    },
    {
        value: 'religion',
        text: 'Religion',
    },
]

/*

Genres to add in the future:

romance
short_stories
mental_health
exercise
nutrition
cooking
autobiography
*/